import {
  SChoiceListPro,
  type SChoiceListProProps,
  type SChoiceListProValue,
} from "@blycare/polar-ui";
import { Skeleton } from "../../skeleton";
import { useBoundField } from "../field-state";

export function ChoiceList<T extends SChoiceListProValue>({
  loading = false,
  skeletonClassName = "h-8",
  ...props
}: Omit<SChoiceListProProps<T>, "name" | "values" | "onChange" | "onBlur" | "error"> & {
  /** 数据还没到时只画占位骨架。 */
  loading?: boolean;
  /** 骨架的高度按选项数量给：默认一行控件，长列表自己传。 */
  skeletonClassName?: string;
}) {
  const { field, error, handleBlur } = useBoundField<T | T[]>();
  if (loading) return <Skeleton className={skeletonClassName} />;
  const values = Array.isArray(field.state.value) ? field.state.value : [field.state.value];
  return (
    <SChoiceListPro
      {...props}
      name={field.name}
      values={values}
      error={error}
      onChange={(next) => {
        if (props.multiple) field.handleChange(next);
        else if (next[0] !== undefined) field.handleChange(next[0]);
        handleBlur();
      }}
      onBlur={handleBlur}
    />
  );
}
